import React from 'react';

import { MarkbookContent } from './MarkbookContent';
import { MarkbookLayout } from './MarkbookLayout';

export const MarkbookPage: React.FC = () => {
  return (
    <MarkbookLayout>
      <MarkbookContent />
    </MarkbookLayout>
  );
};
